import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files (to be created)
import en from "./locales/en/translation.json";
import fr from "./locales/fr/translation.json";

// Detect language from URL path ("/en/" or "/fr/"), fallback to browser language, then to "en"
function detectLanguage(): string {
  if (typeof window !== "undefined") {
    const match = window.location.pathname.match(/^\/(fr|en)(\/|$)/);
    if (match) {
      return match[1];
    }
    const langs = navigator.languages || [navigator.language];
    if (langs.some((lang) => lang.toLowerCase().startsWith("fr"))) {
      return "fr";
    }
  }
  return "en";
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: detectLanguage(),
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;